/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneRecommendedArticles as ResolvedStandaloneRecommendedArticles } from 'base/components/standalone/RecommendedArticles';

export const RecommendedArticles: typeof ResolvedStandaloneRecommendedArticles = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneRecommendedArticles {...props} />
    );
});

export type RecommendedArticlesProps = PropsFromComponent<typeof RecommendedArticles>;

/** @deprecated Use slot architecture instead */
export const RecommendedArticlesWith = (extras: DynamicStandaloneExtras): typeof RecommendedArticles => {
    return function RecommendedArticles(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'RecommendedArticles');
        return <ResolvedStandaloneRecommendedArticles {...mergeProps({ options: { theme } }, props)} />;
    }
}